import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutLoadBoardsTable extends Layout {
    panelSecondaryFilters: Panel;
    sourceLoadboards: DataSource;
    sourceMovement: DataSource;
    tableLoadboards: Table;
}
